import React from 'react'
import Quotegeneratot from "./component/Quotegenerator"

function App() {
  return (
    <div>
      <Quotegeneratot />
    </div>
  )
}

export default App